import './index.css';

import App from './App';
import React from 'react';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import ScrollToTop from './helpers/ScrollToTop';
import { Toaster } from 'react-hot-toast';
import { createRoot } from "react-dom/client";
import reportWebVitals from './reportWebVitals';
import { AUTH_LOCAL_STORAGE_KEYS, AUTH_COOKIE_NAMES } from './utils/authStorageKeys';

// ─────────────────────────────────────────────────────────────────────────────
// BUILD VERSION CONFIG
// Bump `currentBuildVersion` on every deploy.
// Set `forceLogoutOnVersionChange = true` when you want ALL users to be
// signed out on the next deploy (e.g. breaking auth schema change).
// Reset it back to false after that deploy is live.
// ─────────────────────────────────────────────────────────────────────────────
const currentBuildVersion = '1.0.8';
const forceLogoutOnVersionChange = true; // ← true = logout all users on next deploy

try {
  const storedBuildVersion = localStorage.getItem('buildVersion');

  if (!storedBuildVersion || storedBuildVersion !== currentBuildVersion) {

    if (forceLogoutOnVersionChange) {
      // ── FORCE LOGOUT ─────────────────────────────────────────────────────
      // Wipe everything including auth — user will land on sign-in page.
      localStorage.clear();
      sessionStorage.clear();

      // Clear auth cookies
      AUTH_COOKIE_NAMES.forEach(name => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });

      localStorage.setItem('buildVersion', currentBuildVersion);
      // AuthContext will detect missing token and redirect to /sign-in automatically.

    } else {
      // ── PRESERVE SESSION (default) ────────────────────────────────────────
      // Keep all auth data so the user stays logged in across deploys.
      const keysToPreserve = [...AUTH_LOCAL_STORAGE_KEYS, 'buildVersion'];
      const savedData = {};
      keysToPreserve.forEach(key => {
        const value = localStorage.getItem(key);
        if (value !== null) savedData[key] = value;
      });

      localStorage.clear();
      sessionStorage.clear();

      Object.entries(savedData).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });

      localStorage.setItem('buildVersion', currentBuildVersion);
    }
  }
} catch (error) {
  // Storage may be unavailable (private-browsing restrictions, etc.)
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Router basename='/'>
    <ScrollToTop />
    <Toaster />
    <App />
  </Router>
);
reportWebVitals();



// sudo scp -r ./build/* /var/www/build/
